if (!global.googletag) {
  global.googletag = {};
}
if (!global.googletag.cmd) {
  global.googletag.cmd = [];
}
